import { createReducer, on } from '@ngrx/store';
import * as fromActions from './login.actions';
import { IFederatedLoginResponse } from '../../../models';
import { ActionStateCreator, IActionState } from '../../../utils';

export interface ILoginState {
  federatedLoginData: IFederatedLoginResponse;
  resendVerifyEmailState: IActionState;
}

export const initialState: ILoginState = {
  federatedLoginData: null,
  resendVerifyEmailState: ActionStateCreator.create(),
};

export const loginReducer = createReducer(
  initialState,

  on(fromActions.LoadFederatedLoginData, state => {
    return {
      ...state,
    };
  }),

  on(fromActions.LoadFederatedLoginDataSuccess, (state, { federatedLoginData }) => {
    return {
      ...state,
      federatedLoginData,
    };
  }),
  on(fromActions.ResendVerifyEmail, state => {
    return {
      ...state,
      resendVerifyEmailState: ActionStateCreator.onStart(),
    };
  }),
  on(fromActions.ResendVerifyEmailFailed, (state, { error }) => {
    return {
      ...state,
      resendVerifyEmailState: ActionStateCreator.onError(error),
    };
  }),
  on(fromActions.ResendVerifyEmailSuccess, state => {
    return {
      ...state,
      resendVerifyEmailState: ActionStateCreator.onSuccess(),
    };
  })
);

export const getResendVerifyEmailActionState = (state: ILoginState) => state.resendVerifyEmailState;
